<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter1">Contents</h1>
<p class="toc1"><a href="#/int">Introduction</a></p>
<p class="toc"><a href="#/c01"><span class="tocs">CHAPTER 1</span><br/>For You and Your Friends</a></p>
<p class="toc1"><a href="#/c01#sec1">Laptop Sleeve</a></p>
<p class="toc1"><a href="#/c01#sec2">Phone Case Cover</a></p>
<p class="toc1"><a href="#/c01#sec3">Bookmark</a></p>
<p class="toc1"><a href="#/c01#sec4">Washi Bead Necklace</a></p>
<p class="toc1"><a href="#/c01#sec5">Initial Necklace</a></p>
<p class="toc1"><a href="#/c01#sec6">Braided Friendship Bracelet</a></p>
<p class="toc1"><a href="#/c01#sec7">Toilet Paper Roll Bracelet</a></p>
<p class="toc1"><a href="#/c01#sec8">Popsicle Stick Bracelet</a></p>
<p class="toc1"><a href="#/c01#sec9">Feather Dangle Earrings</a></p>
<p class="toc1"><a href="#/c01#sec10">Stud Earrings</a></p>
<p class="toc1"><a href="#/c01#sec11">Bobby Pin Flower</a></p>
<p class="toc1"><a href="#/c01#sec12">Bow Ring</a></p>
<p class="toc1"><a href="#/c01#sec13">Barrette</a></p>
<p class="toc"><span href="#/c02" title="Link target outside of Sample"><span class="tocs">CHAPTER 2</span><br/>For Your Room</span></p>
<p class="toc1"><span href="#/c02#sec14" title="Link target outside of Sample">Washi Tape Keyboard</span></p>
<p class="toc1"><span href="#/c02#sec15" title="Link target outside of Sample">Charger and Cable Markers</span></p>
<p class="toc1"><span href="#/c02#sec16" title="Link target outside of Sample">Tin Can Organizer</span></p>
<p class="toc1"><span href="#/c02#sec17" title="Link target outside of Sample">Drawer Organizer</span></p>
<p class="toc1"><span href="#/c02#sec18" title="Link target outside of Sample">Upcycled Desk</span></p>
<p class="toc1"><span href="#/c02#sec19" title="Link target outside of Sample">Wall Calendar</span></p>
<p class="toc1"><span href="#/c02#sec20" title="Link target outside of Sample">Jewelry Organizer</span></p>
<p class="toc1"><span href="#/c02#sec21" title="Link target outside of Sample">Shoebox Upcycle</span></p>
<p class="toc1"><span href="#/c02#sec22" title="Link target outside of Sample">Light Switch Plate</span></p>
<p class="toc1"><span href="#/c02#sec23" title="Link target outside of Sample">Cutout Art</span></p>
<p class="toc1"><span href="#/c02#sec24" title="Link target outside of Sample">Quote Art</span></p>
<p class="toc1"><span href="#/c02#sec25" title="Link target outside of Sample">Temporary Wallpaper</span></p>
<p class="toc1"><span href="#/c02#sec26" title="Link target outside of Sample">Bed Headboard</span></p>
<p class="toc"><span href="#/c03" title="Link target outside of Sample"><span class="tocs">CHAPTER 3</span><br/>For the Holidays</span></p>
<p class="toc1"><span href="#/c03#sec27" title="Link target outside of Sample">Birthday Candle Card</span></p>
<p class="toc1"><span href="#/c03#sec28" title="Link target outside of Sample">Valentine’s Day Card</span></p>
<p class="toc1"><span href="#/c03#sec29" title="Link target outside of Sample">Valentine’s Day Heart Streamers</span></p>
<p class="toc1"><span href="#/c03#sec30" title="Link target outside of Sample">Twist Ties</span></p>
<p class="toc1"><span href="#/c03#sec31" title="Link target outside of Sample">Christmas Matchbox Drawers</span></p>
<p class="toc1"><span href="#/c03#sec32" title="Link target outside of Sample">Candy Cane Christmas Ornament</span></p>
<p class="toc1"><span href="#/c03#sec33" title="Link target outside of Sample">Christmas Tree Card</span></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample"><span class="tocs">CHAPTER 4</span><br/>For School</span></p>
<p class="toc1"><span href="#/c04#sec34" title="Link target outside of Sample">Locker Pen and Pencil Holder</span></p>
<p class="toc1"><span href="#/c04#sec35" title="Link target outside of Sample">Locker Mirror</span></p>
<p class="toc1"><span href="#/c04#sec36" title="Link target outside of Sample">Locker Dry-Erase Board</span></p>
<p class="toc1"><span href="#/c04#sec37" title="Link target outside of Sample">Magnets</span></p>
<p class="toc1"><span href="#/c04#sec38" title="Link target outside of Sample">Paper Clip Bookmark</span></p>
<p class="toc1"><span href="#/c04#sec39" title="Link target outside of Sample">Cloud and Raindrop Bookmark</span></p>
<p class="toc1"><span href="#/c04#sec40" title="Link target outside of Sample">Pencil Case Roll</span></p>
<p class="toc1"><span href="#/c04#sec41" title="Link target outside of Sample">Washi Tape Pens</span></p>
<p class="toc1"><span href="#/c04#sec42" title="Link target outside of Sample">Washi Tape Pencils</span></p>
<p class="toc1"><span href="#/c04#sec43" title="Link target outside of Sample">Supply Labels</span></p>
<p class="toc1"><span href="#/c04#sec44" title="Link target outside of Sample">Organization Labels</span></p>
<p class="toc1"><span href="#/c04#sec45" title="Link target outside of Sample">Textbook Cover</span></p>
<p class="toc1"><span href="#/c04#sec46" title="Link target outside of Sample">Composition Book</span></p>
<p class="toc1"><span href="#/c04#sec47" title="Link target outside of Sample">Washi Tape Stickers</span></p>
<p class="toc"><span href="#/cop" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?602c5259